import { GLOBAL_CATALOGS } from '../types';


export const queryContactMenus = (list = []) => (dispatch, getState) => {
  dispatch({
    type: GLOBAL_CATALOGS.SignOff.Root,
    payload: list
  });
};
